export function getFromStorage<T>(
  key: string,
  storage: Storage = sessionStorage,
): T | null {
  try {
    const item = storage.getItem(key);
    if (!item) return null;
    return JSON.parse(item) as T;
  } catch (error) {
    console.error(`Error parsing storage key "${key}":`, error);
    return null;
  }
}
